const selector = ".wp-block-steam-blocks-social-posts__media";
const nodes = document.querySelectorAll(selector);

nodes.forEach((node) => {
	const video = node.querySelector("video");
	const button = node.querySelector("button");

	if (video && button) {
		button.addEventListener("click", (event) => {
			event.preventDefault();
			video.play();
		});

		video.addEventListener("play", () => {
			node.classList.add("is-playing");
		});

		video.addEventListener("pause", () => {
			node.classList.remove("is-playing");
		});

		video.addEventListener("ended", () => {
			node.classList.remove("is-playing");
		});
	}
});
